import React, { useState } from "react"

import NotForGuestsPopup from "./"

import { PageTitle, SectionTitle, Block, BlockTitle } from "@sandbox/Sandbox"
import Kiosk from "@ui/Kiosk"

const Sandbox: React.FC = () => {
  const [ show, setShow ] = useState(false)

  return <>
    <SectionTitle>
      NotForGuestsPopup <a onClick={() => setShow(true)}>SHOW!</a>
    </SectionTitle>
    <Kiosk>
      {show && <NotForGuestsPopup closePopup={() => setShow(false)} />}
    </Kiosk>
  </>
}

export default ["Popups", Sandbox]
